/**
 * @author：
 * @update：
 * @description：
 **/
import {
    messageGet,
    messagePost,
    messageEdit,
    messageSeach,
    messageSceneGet,
    messageDel,
    messageDisTrue,
    messageDisFalse
} from "@/api/message";
import CusPagination from "@/components/cusPagination";
import fa from "element-ui/src/locale/lang/fa";
import id from "element-ui/src/locale/lang/id";

export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            addOrEdit: true,//新建修改title
            addDialog: false,
            rowId: '',
            options: [],//场景下拉
            searchForm: {
                title: '',
                enable: ''
            },
            ruleForm: {
                scene: '',
                title: '',
                content: '',
                message: true,
                messageTmplId: '',
                enable: true,
            },
            rules: {
                scene: [
                    {required: true, message: '请输入场景', trigger: 'change'},
                ],
                title: [
                    {required: true, message: '请输入模板标题', trigger: 'blur'},
                    {min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur'}
                ],
                content: [
                    {required: true, message: '请输入模板内容', trigger: 'blur'},
                ],
                message: [
                    {required: true, message: '请输入公告内容', trigger: 'blur'},
                ],
                messageTmplId: [
                    {required: true, message: '请输入短信模板ID', trigger: 'blur'},
                ],
            },
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
        };
    },
    // 自定义方法
    methods: {
        seachBtn() {
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.title = '';
            this.searchForm.enable = '';
            this.getList();
        },
        //获取数据
        getList() {
            this.$ajax.get(messageGet, {
                title: this.searchForm.title,
                enable: this.searchForm.enable,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                }
            }, (err) => {
                console.log(err);
            })
        },
        //新增
        addBtn() {
            this.$ajax.get(messageSceneGet).then((res) => {
                if (res.status === 200) {// 成功了
                    this.options = res.data
                }
            }, (err) => {
                console.log(err);
            })

            this.ruleForm.scene = ''
            this.ruleForm.title = ''
            this.ruleForm.content = ''
            this.ruleForm.message = true
            this.ruleForm.messageTmplId = ''
            this.ruleForm.enable = true

            this.addOrEdit = true;
            this.addDialog = true;
        },
        //编辑
        editClick(row) {
            this.ruleForm.scene = row.scene;
            this.ruleForm.title = row.title;
            this.ruleForm.content = row.content;
            this.ruleForm.message = row.message;
            this.ruleForm.messageTmplId = row.messageTmplId;
            this.ruleForm.enable = row.enable;
            this.rowId = row.id
            this.$ajax.get(messageSceneGet).then((res) => {
                if (res.status === 200) {// 成功了
                    this.options = res.data
                }
            }, (err) => {
                console.log(err);
            })
            this.addOrEdit = false;
            this.addDialog = true;
        },
        //是否发送短信
        checkboxSel(){
            if (this.ruleForm.message == false){
                this.rules = {
                    scene: [
                        {required: true, message: '请输入场景', trigger: 'change'},
                    ],
                    title: [
                        {required: true, message: '请输入模板标题', trigger: 'blur'},
                        {min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入模板内容', trigger: 'blur'},
                    ],
                    message: [
                        {required: true, message: '请输入公告内容', trigger: 'blur'},
                    ]
                }
            }else if (this.ruleForm.message == true){
                this.rules = {
                    scene: [
                        {required: true, message: '请输入场景', trigger: 'change'},
                    ],
                    title: [
                        {required: true, message: '请输入模板标题', trigger: 'blur'},
                        {min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入模板内容', trigger: 'blur'},
                    ],
                    message: [
                        {required: true, message: '请输入公告内容', trigger: 'blur'},
                    ],
                    messageTmplId: [
                        {required: true, message: '请输入短信模板ID', trigger: 'blur'},
                    ],
                }
            }

        },
        //保存
        submitBtn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.addOrEdit == true) {
                        this.$ajax.post(messagePost, {
                            scene: this.ruleForm.scene,
                            title: this.ruleForm.title,
                            content: this.ruleForm.content,
                            message: this.ruleForm.message,
                            messageTmplId: this.ruleForm.messageTmplId,
                            enable: this.ruleForm.enable,
                        }).then((res) => {
                            this.addDialog = false;
                            this.getList();
                            this.$message({
                                message: '新建消息模板成功',
                                type: 'success'
                            });
                        }, (err) => {
                            console.log(err);
                        })
                    } else if (this.addOrEdit == false) {
                        this.$ajax.put(messageEdit(this.rowId), {
                            id:this.rowId,
                            scene: this.ruleForm.scene,
                            title: this.ruleForm.title,
                            content: this.ruleForm.content,
                            message: this.ruleForm.message,
                            messageTmplId: this.ruleForm.messageTmplId,
                            enable: this.ruleForm.enable,
                        }).then((res) => {
                            this.addDialog = false;
                            this.getList();
                            this.$message({
                                message: '修改消息模板成功',
                                type: 'success'
                            });
                        }, (err) => {
                            console.log(err);
                        })
                    }
                }
            })
        },
        //取消
        cancelBtn(formName) {
            this.$refs[formName].resetFields();
            this.addDialog = false;
        },
        //启禁用
        enableClick(row) {
            if (row.enable == true) {
                this.$ajax.put(messageDisFalse(row.id)).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.getList();
                    }
                }, (err) => {
                    console.log(err);
                })
            } else if (row.enable == false) {
                this.$ajax.put(messageDisTrue(row.id)).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.getList();
                    }
                }, (err) => {
                    console.log(err);
                })
            }
        },
        //删除
        delClick(row) {
            this.$confirm('此操作将永久删除此消息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax.delete(messageDel(row.id)).then((res) => {
                    if (res.status === 200) {// 成功了
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getList();
                    }
                }, (err) => {
                    this.$message.error(err.data);
                })
            }).catch(() => {
                // this.$message({
                //     type: 'info',
                //     message: '已取消删除'
                // });
            });

        },
        //创建人
        returnUserInfo(userInfo){
            let name = '--';
            if(userInfo.type=="ENTERPRISE"){
                name = userInfo.legalPerson;
            }else{
                if(userInfo.state=="CERTIFIED"){
                    name = userInfo.realName
                }else{
                    name = userInfo.nickname
                }
            }
            return name
        },
    },
    // 数据观察监听
    watch: {
        currentPage(newData,oldData){
            this.getList()
        },
        pageSize(newData,oldData){
            this.getList()
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.getList();
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
